import SidModalDropdown from 'components/PersonalizedPreviewPlacements/SidModalDropdown/SidModalDropdown';
import { withPersonalizedPlacementProps } from 'viewModel/personalizedPreviewPlacements/withPersonalizedPlacementProps';

export default withPersonalizedPlacementProps(SidModalDropdown);
